import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { CertificateTemplateFragmentDoc } from '../../../fragments/generated/CertificateTemplate';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CertificateTemplatesQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  filters?: Types.InputMaybe<Types.CertificateTemplatesFilters>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type CertificateTemplatesQuery = { certificateTemplates: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string, description?: string | null, createdAt: string, updatedAt: string, status: Types.CertificateTemplateStatusEnum, preview: { url?: string | null }, modelRequirement: { user?: Array<string> | null }, createdBy?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null } }> | null } };


export const CertificateTemplatesDocument = /*#__PURE__*/ gql`
    query certificateTemplates($sort: [SortType!], $filters: CertificateTemplatesFilters, $after: String, $first: Float) {
  certificateTemplates(
    filters: $filters
    sort: $sort
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...CertificateTemplate
      }
    }
  }
}
    ${CertificateTemplateFragmentDoc}
${UserFragmentDoc}`;

export function useCertificateTemplatesQuery(options?: Omit<Urql.UseQueryArgs<CertificateTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<CertificateTemplatesQuery, CertificateTemplatesQueryVariables>({ query: CertificateTemplatesDocument, ...options });
};